import {GetFormattedWarehouseTargetData} from '@/models/WarehouseModel'
import {getWarehouseList} from '@/services/ProductsService/Fullfillment/warehouse'
import {WarehouseTargetsColConfig} from '@/services/MockData/Products/Fullfillment/WarehouseTargetsColConfig'
import {useQueries} from '@tanstack/react-query'

export const useWarehouseTargets = () => {
  const results = useQueries({
    queries: [{queryKey: ['WAREHOUSE_TARGETS'], queryFn: getWarehouseList}],
  })
  return {
    warehouseTargetsData: GetFormattedWarehouseTargetData(results?.[0]?.data || {}),
    warehouseTargetsColConfigData: WarehouseTargetsColConfig,
  }
}
